var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('w-btn',{attrs:{"color":_vm.error ? 'red' : 'grey darken-2',"loading":_vm.loading,"disabled":_vm.disabled,"text":_vm.$t('common.lock'),"icon":_vm.error ? 'mdi-alert' : 'mdi-lock'},on:{"press":_vm.press}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }